












import Masthead from './scripts';
export default Masthead;
